import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getSDKImgObj, getSDKImgObjFormat } from "assets/js/scenes/brand/utils";
import { getUrlsBasedOnLanguage } from "utils/languages";
import {
	getBrandImage,
	getProfileLogoUrl,
	getUrlQueryParam,
	isValidUrl,
} from "utils/urlUtils";
import { loadImage } from "utils/dataUtils";
import store from "assets/js/store";

const ListRedirectionParamLoader = (props) => {
	const [goodImg, setGoodImg] = useState(false);
	const [imgUrl, setImgUrl] = useState(null);
	const [imgWidth, setImgWidth] = useState(null);

	const listOwner = getUrlQueryParam("a");
	const listName = getUrlQueryParam("listName");
	const listId = getUrlQueryParam("l");
	const formId = getUrlQueryParam("f");
	const campaignId = getUrlQueryParam("c");
	const type = getUrlQueryParam("type");
	const action = getUrlQueryParam("action");
	const accountName = getUrlQueryParam("aName");

	function addUtm(type = "", id = "", medium = "") {
		return `?utm_campaign=${type}_${id}&utm_medium=${medium}&utm_source=${store.getState().brand?.name
			}&utm_content=partner_logo`;
	}

	useEffect(() => {
		if (listOwner && props.publicUserBrand.brand) {
			let curImgUrl = getProfileLogoUrl(listOwner);

			if (props.publicUserBrand.brand?.client_config?.brand_repo?.url) {
				if (props.publicUserBrand.brandRepo) {
					const userBrandLogo =
						props.publicUserBrand.brand?.list_redirection?.logo;

					if (isValidUrl(userBrandLogo?.id)) {
						setImgUrl(userBrandLogo.id);
						setGoodImg(true);
					} else {
						const sdkImgObj = getSDKImgObj(userBrandLogo?.id);
						const sdkImgFormat = getSDKImgObjFormat(
							sdkImgObj?.formats,
							userBrandLogo?.type
						);

						if (userBrandLogo?.width) {
							setImgWidth(userBrandLogo.width);
						}

						if (sdkImgFormat?.src) {
							setImgUrl(sdkImgFormat.src);
							setGoodImg(true);
						} else {
							if (typeof userBrandLogo === "string" && (isValidUrl(userBrandLogo) || userBrandLogo.startsWith("data:image/"))) {
								setImgUrl(userBrandLogo);
								setGoodImg(true);
							} else {
								loadImage(curImgUrl).then(() => {
									setImgUrl(curImgUrl);
									setGoodImg(true);
								}).catch(() => { });
							}
						}
					}
				}
			} else {
				const userBrandLogo = props.publicUserBrand.brand?.list_redirection?.logo;

				if (typeof userBrandLogo === "string" && (isValidUrl(userBrandLogo) || userBrandLogo.startsWith("data:image/"))) {
					setImgUrl(userBrandLogo);
					setGoodImg(true);
				} else {
					loadImage(curImgUrl).then(() => {
						setImgUrl(curImgUrl);
						setGoodImg(true);
					}).catch(() => { });
				}
			}
		}
	}, [props.publicUserBrand.brand, props.publicUserBrand.brandRepo]);

	const imgExtraAttr = {};

	if (imgWidth) {
		imgExtraAttr.style = { width: imgWidth + "px" };
	}
	return (
		<>
			{props.publicUserBrand.brand && (
				<>
					{React.cloneElement(props.children, {
						imgExtraAttr: imgExtraAttr,
						listName: listName,
						listId: listId,
						formId: formId,
						campaignId: campaignId,
						type: type,
						imgUrl: imgUrl,
						goodImg: goodImg,
						action: action,
						addUtm: addUtm,
						logo: props.logo,
						publicUserBrand: props.publicUserBrand?.brand,
						resellerName: props.resellerName,
						accountName: accountName,
					})}
				</>
			)}
		</>
	);
};

ListRedirectionParamLoader.propTypes = {
	logo: PropTypes.string,
	resellerName: PropTypes.string,
	history: PropTypes.object,
	publicUserBrand: PropTypes.object,
	children: PropTypes.object,
};

export default withRouter(
	connect((state) => {
		return {
			logo: getBrandImage(state?.brand?.images?.injected_logo ? "injected_logo" : "logo"),
			resellerName: state.brand?.name,
			publicUserBrand: state.publicUserBrand,
		};
	}, null)(ListRedirectionParamLoader)
);
